import React from "react";
import { Landing } from "../../components";
import { homeObjectFour } from "./data";

const SignUp = () => {
  return (
    <>
      <Landing {...homeObjectFour} />
    </>
  );
};

export default SignUp;
